import "../application.css";
import { BookOpen, Check, Copy, Heart, Inbox, Link, List, LogIn, LogOut, Mail, Plus, Settings, Sparkles, Tag, Trash2, TrendingDown, TrendingUp, User, UserCheck, UserPlus, UserX, createIcons } from "lucide";

createIcons({
  icons: {
    BookOpen,
    Check,
    Copy,
    Heart,
    Inbox,
    Link,
    List,
    LogIn,
    LogOut,
    Mail,
    Plus,
    Settings,
    Sparkles,
    Tag,
    Trash2,
    TrendingDown,
    TrendingUp,
    User,
    UserCheck,
    UserPlus,
    UserX,
  },
});
